import { i18n } from '../../lang'

export const mpOrderColumnList = [
  { type: 'order_number', custom: { width: '106' } },
  { type: 'order_date', custom: { width: '86' } },
  { type: 'payment_method', custom: { width: '118' } },
  { type: 'payment_status', custom: { width: '110' } },
  { type: 'currency', custom: { width: '72' } },
  { type: 'delivery', custom: { width: '70' } },
  { type: 'discount', custom: { width: '74' } },
  { type: 'amount_paid_by_point', custom: { width: '94' } },
  { type: 'subtotal', custom: { width: '70' } },
  { type: 'total', custom: { width: '70' } },
  { type: 'shipment.shipment_status', custom: { width: '80' } },
  { type: 'shipment.tracking_url', custom: { width: '80' }, title: i18n.t('table.shipment.tracking_info') },
  { type: 'shipment.tracking_documents', custom: { width: '80' }, title: i18n.t('table.shipment.tracking_documents') },
]

export const mpOrderDetailColumnList = [
  { type: 'store_displayname', custom: { 'min-width': '200' } },
  { type: 'product_name', custom: { 'min-width': '200' } },
  { type: 'variant_name', custom: { 'min-width': '200' } },
  { type: 'currency', custom: { width: '80' } },
  { type: 'unit_price', custom: { 'min-width': '100' } },
  { type: 'quantity', custom: { 'min-width': '100' } },
  { type: 'price', custom: { 'min-width': '100' } },
]

export const paymentStatusList = [
  { value: '', label: 'All' },
  { value: '1', label: 'Pending' },
  { value: '2', label: 'Paid' },
  { value: '3', label: 'Refunded' },
  { value: '4', label: 'Partially Refunded' },
  { value: '5', label: 'Pending Review' },
]
